(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Policy-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var allPanels = document.querySelectorAll('.panel');
    allPanels.forEach(panel => panel.style.display = 'none');

    var accordionItems = document.querySelectorAll('.accordion');
    accordionItems.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('aactive');

// Remove "aactive" class from sibling elements
        var siblings = getSiblings(this);
        siblings.forEach(sibling => sibling.classList.remove('aactive'));

// Hide all panels
        allPanels.forEach(panel => panel.style.display = 'none');

// Show the next panel
        var nextPanel = this.nextElementSibling;
        if (nextPanel.classList.contains('panel')) {
          nextPanel.style.display = 'block';
        }
      });
    });
  });

// Helper function to get sibling elements
  function getSiblings(elem) {
    var siblings = [];
    var sibling = elem.parentNode.firstChild;
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  }

  } catch(e) { console.error(e); }
})();
})();
